import * as yup from 'yup';
import { VALIDATION_ERROR } from 'utils/enums';

export const createServiceSchema = yup.object().shape({
	name: yup.string().min(2, VALIDATION_ERROR.MIN_LENGTH).required(VALIDATION_ERROR.REQUIRED),
});
